import * as wasm from 'sched';
import { useDatabaseEntity } from './useDatabaseEntity';

export interface OutcomeDetails {
  id: string;
  title: string;
  description?: string;
  remoteReference?: wasm.RemoteReference;
  completionCriterion?: wasm.CompletionCriterion;
  deadlines?: wasm.Deadline[];
}

export function useOutcome(outcomeId: string | undefined) {
  const { entity, loading, error } = useDatabaseEntity<OutcomeDetails>(outcomeId, {
    entityType: 'Outcome',
    build: async (database, id) => {
      const obj = database.outcomes()[id];
      if (!obj) return null;

      // Read sync fields up front so we can fall back to a partial result
      // if the async remote-reference fetch fails.
      const base: OutcomeDetails = {
        id,
        title: obj.title(),
        description: obj.description(),
        completionCriterion: obj.completion_criterion(),
        deadlines: obj.deadlines(),
      };

      try {
        const remoteReference = await obj.remote_reference();
        return { ...base, remoteReference };
      } catch (err) {
        console.error('Error fetching outcome remote reference:', err);
        return base;
      }
    },
  });
  return { outcome: entity, loading, error };
}
